import React from "react";
import CalendarCell from "./CalendarCell";

const DEFAULT_EVENT_HEIGHT = 28;
const DEFAULT_EVENT_WIDTH = 100;
const VIRTUALIZATION_BUFFER = 1000;

const getWindowSize = () => ({
  width: typeof window !== "undefined" ? window.innerWidth : 0,
  height: typeof window !== "undefined" ? window.innerHeight : 0,
});

const CalendarEvents = ({ events }) => {
  const [windowSize, setWindowSize] = React.useState(getWindowSize);
  const [scrollPosition, setScrollPosition] = React.useState({
    horizontal: 0,
    vertical: 0,
  });

  React.useEffect(() => {
    const handleResize = () => setWindowSize(getWindowSize());
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    const horizontalNode = document.getElementById("futureListCustomScroll");
    const verticalNode = document.getElementById("calendarCustomScroll");

    const handleScroll = () => {
      setScrollPosition({
        horizontal: horizontalNode?.scrollLeft ?? 0,
        vertical: verticalNode?.scrollTop ?? 0,
      });
    };

    horizontalNode?.addEventListener("scroll", handleScroll);
    verticalNode?.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      horizontalNode?.removeEventListener("scroll", handleScroll);
      verticalNode?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const visibleEvents = React.useMemo(() => {
    const viewportWidth = windowSize.width;
    const viewportHeight = windowSize.height;

    const horizontalStart = scrollPosition.horizontal - VIRTUALIZATION_BUFFER;
    const horizontalEnd =
      scrollPosition.horizontal + viewportWidth + VIRTUALIZATION_BUFFER;
    const verticalStart = scrollPosition.vertical - VIRTUALIZATION_BUFFER;
    const verticalEnd =
      scrollPosition.vertical + viewportHeight + VIRTUALIZATION_BUFFER;

    return events.filter((event) => {
      const eventLeft = event?.xPos ?? 0;
      const eventRight = eventLeft + (event?.width ?? DEFAULT_EVENT_WIDTH);
      const eventTop = event?.yPos ?? 0;
      const eventBottom = eventTop + (event?.height ?? DEFAULT_EVENT_HEIGHT);

      return (
        eventRight >= horizontalStart &&
        eventLeft <= horizontalEnd &&
        eventBottom >= verticalStart &&
        eventTop <= verticalEnd
      );
    });
  }, [events, scrollPosition, windowSize]);

  return (
    <>
      {visibleEvents.map((event, index) => (
        <CalendarCell key={index} event={event} date={event.event_date} />
      ))}
    </>
  );
};

export default CalendarEvents;